export const fi = {
  txt_upload_data: 'Lataa',
  txt_allow_data_type: 'Tiputa tiedostosi tänne',
  txt_select_files: 'Valitse tiedosto',
  txt_select_option: 'Valitse vaihtoehto',
  txt_back: 'Takaisin',
  txt_continue: 'Jatka',
  txt_cancel: 'Peruuta',
  txt_sheet_selection: 'Taulukon valinta',
  txt_sheet_selection_description:
    'Valitse taulukko, jonka haluat tuoda tiedostostasi.',
  txt_select_header: 'Otsikkorivin valinta',
  txt_download_template: 'Lataa mallipohja',
  txt_download_template_desc:
    'Voit ladata olemassa olevan tiedostosi ensin painamalla "{{ button_name }}". Jos kuitenkin haluat käyttää mallipohjaa, löydät Excel- ja CSV-mallipohjat ylhäältä.',
  txt_download_excel: 'Excel-mallipohja (.xlsx)',
  txt_download_excel_modal: 'Excel (.xlsx)',
  txt_download_csv: 'CSV-mallipohja',
  txt_download_csv_modal: 'CSV',
  txt_all: 'Kaikki',
  txt_select: 'Valitse',
  txt_export_as_excel: 'Vie Excel-tiedostona',
  txt_title_submit_success: 'Tuonti onnistui',
  txt_example: 'Esim.',
  txt_title_confirm_submit_data_without_error: 'Valmis lähettämään?',
  txt_confirm_submit_data_with_error:
    'Oletko varma, että haluat lähettää tietosi? Virheitä sisältävät rivit eivät kelpaa. Jos kyllä, käytä "Lähetä"-painiketta. Muuten, paina "Takaisin"-painiketta.',
  txt_confirm_submit_data_without_error:
    'Oletko varma, että haluat lähettää tietosi? Jos kyllä, käytä "Lähetä"-painiketta. Muuten, paina "Takaisin"-painiketta.',
  txt_allow_error_confirm_submit_data_with_error:
    'Oletko varma, että haluat lähettää tietosi? Virheet sisältävät rivit tuodaan myös. Jos kyllä, käytä "Lähetä"-painiketta. Muuten, paina "Takaisin"-painiketta.',
  txt_import_data_error_exceed:
    'Tuontisi tuotti {{error}} virheitä. Jos haluat korjata nämä virheet sovelluksessa, paina "Jatka"-painiketta. Muuten, voit ladata yhdistetyn taulukon Excelina (.xlsx) painamalla "Vie Excelinä"-painiketta.',
  txt_field_required: 'Pakollinen',
  txt_field_category_required: 'Valitse vaihtoehto',
  txt_field_invalid_format_number: 'Numero vaaditaan',
  txt_field_invalid_format_number_int: 'Desimaaleja ei sallita',
  txt_field_invalid_format_number_float: 'Numero vaaditaan',
  txt_field_not_in_options: 'Valitse kelvollinen vaihtoehto',
  txt_field_invalid_regex_format: 'Virheellinen formaatti',
  txt_field_unique: 'Uniikki arvo vaaditaan',
  txt_excel_tag_required: 'VAADITAAN',
  txt_excel_tag_unique: 'UNIIKKI',
  txt_excel_tag_required_unique: 'VAADITAAN/UNIIKKI',
  txt_excel_description_label: 'Kuvaus:',
  txt_field_required_with:
    'Tämä kenttä on pakollinen, jos MITKÄ tahansa seuraavista kentistä on täytetty: {{columns}}',
  txt_field_required_without:
    'Tämä kenttä on pakollinen, jos MITKÄ tahansa seuraavista kentistä ovat tyhjät: {{columns}}',
  txt_field_required_with_all:
    'Tämä kenttä on pakollinen, jos KAIKKI seuraavat kentät on täytetty: {{columns}}',
  txt_field_required_without_all:
    'Tämä kenttä on pakollinen, jos KAIKKI seuraavat kentät ovat tyhjät: {{columns}}',
  txt_field_required_with_values:
    'Tämä kenttä on pakollinen, jos MITKÄ tahansa seuraavista kentistä sisältävät näitä arvoja: {{columns}}',
  txt_field_required_without_values:
    'Tämä kenttä on pakollinen, jos MITKÄ tahansa seuraavista kentistä ei sisällä näitä arvoja: {{columns}}',
  txt_field_required_with_all_values:
    'Tämä kenttä on pakollinen, jos MITKÄÄN seuraavat kentät sisältävät näitä arvoja: {{columns}}',
  txt_field_required_without_all_values:
    'Tämä kenttä on pakollinen, jos KAIKKI seuraavat kentät eivät sisällä näitä arvoja: {{columns}}',
  txt_close: 'Sulje',
  txt_data_processing: 'Käsitellään tietoja',
  txt_back_page_dialog:
    'Jos painat "Mene takaisin"-painiketta, menetät nykyisen vaiheen edistymisen.',
  txt_close_page_modal:
    'Jos painat "Mene takaisin"-painiketta, menetät kaikkien vaiheiden koko edistymisen.',
  txt_title_sheet_max_entries: 'Liikaa merkintöjä',
  txt_desc_sheet_max_entries:
    'Hyväksymme enintään {{maxEntries}} riviä, ilman sarakeotsikkoa. Harkitse toisen taulukon valitsemista tai tiedostosi jakamista useisiin osiin.',
  txt_dialog_un_matched:
    'Anteeksi, yksi tai useampi vaadittu sarake on määrittämättä: {{unMatched}}',
  txt_or: 'tai',
  txt_progress_upload: 'Lataus',
  txt_progress_sheet_selection: 'Taulukon valinta',
  txt_progress_header_selection: 'Otsikon valinta',
  txt_progress_match_column: 'Vastaavuus-sarakkeet',
  txt_progress_review_entries: 'Tarkista merkinnät',
  txt_confirm_title: 'Oletko varma?',
  txt_massive_error: 'Massiivinen virhe',
  txt_match_column_required: 'Vaadittavat sarakkeet täytyy sovittaa',
  txt_submit_understand: 'Sulje',
  txt_go_back: 'Mene takaisin',
  txt_submit: 'Lähetä',
  txt_title_too_many_files_error: 'Valitse vain yksi tiedosto',
  txt_too_many_files_error:
    'Useita tiedostojen latauksia ei tällä hetkellä tueta. Lataa vain yksi tiedosto.',
  txt_title_upload_valid_file_error: 'Virheellinen tiedosto',
  txt_page_upload_desc: 'Vedä tiedostosi tänne tai selaa ja lataa tiedostosi.',
  txt_select_header_desc: 'Vahvista tai valitse tämän taulukon otsikko.',
  txt_num_sheet_other: '{{count}} taulukot',
  txt_sheet_selection_title:
    'Et voi valita taulukkoa, joka sisältää yli {{maxEntries}} riviä, ilman sarakeotsikkoa.',
  txt_size_import_one: '{{count}} taulukko tuotu.',
  txt_size_import_other: '{{count}} taulukkoa tuotu.',
  txt_delete_button: 'Poista',
  txt_duplicate_button: 'Tuplaa',
  txt_find_error: 'Löydä virhe',
  txt_toggle_error: 'Näytä kaikki rivit, joissa on virheitä',
  txt_one_error: 'Virherivi (1)',
  txt_error_amount: 'Virherivit ({{amountOfErrors}})',
  txt_confirm: 'Vahvista',
  txt_upload_file: 'Ladataan tietoja',
  txt_require_columns: 'Vaaditut sarakkeet',
  txt_show_more: 'Näytä lisää',
  txt_show_less: 'Näytä vähemmän',
  txt_search: 'Haku',
  txt_required: 'Pakollinen',
  txt_not_all_mapped: 'Kaikkia arvoja ei ole sovitettu',
  txt_empty: 'tyhjä',
  txt_unable_match_auto: 'Ei voitu automaattisesti sovittaa',
  txt_match_manual: 'Sovitettu',
  txt_match_auto: 'Automaattisesti sovitettu',
  txt_unable_match: 'Ei sovitettu',
  txt_recommended_match: 'Suositeltu vastaavuus',
  txt_others: 'Muut',
  txt_percent_row_have_values: '{{percent}} rivistä sisältää arvon',
  txt_full_screen: 'Koko näyttö',
  txt_search_result: 'Hakutulos',
  txt_title_warning_screen: 'Näytön leveys on liian pieni',
  txt_warning_screen:
    'Käytä toista laitetta tai lisää näytön leveyttä tuodaksesi tietosi',
  txt_title_warning_screen_modal_false: 'Komponentin leveys on liian pieni',
  txt_warning_screen_modal_false:
    'Käytä toista laitetta tai lisää näytön tai komponentin leveyttä tuodaksesi tietosi',
  txt_complete_imports: 'Täydellinen tuonti',
  txt_no_data_in_sheet_title: 'Tietoja ei voida käsitellä',
  txt_no_data_in_sheet_description:
    'Lataa tiedosto, joka sisältää kelvollisia tietoja.',
  txt_not_export_file:
    'Tämä toiminnallisuus on poistettu käytöstä, koska olet tuonut yli 100.000 riviä.',
  txt_allow_multiple_data_type: 'Tiputa tiedostosi tänne',
  txt_allow_multiple_select_files: 'Valitse tiedostoja',
  txt_multiple_sheet_selection_description:
    'Valitse yksi tai useampi taulukko, jonka haluat tuoda. Jos valitset useita taulukkoja, kaikkien taulukkojen on sisällettävä avainsarake niiden yhdistämiseksi.',
  txt_page_multiple_upload_desc:
    'Vedä tiedostosi tänne tai selaa ja lataa tiedostosi.',
  txt_num_one_sheet_other: '{{count}} taulukko',
  txt_size_multi_import_one: '{{sheet}} taulukko tuotu.',
  txt_size_multi_import_other: '{{sheet}} taulukkoa tuotu.',
  txt_allow_multiple_upload_file: 'Ladataan tietoja',
  txt_progress_join_column: 'Yhdistä taulukot',
  txt_add_files: 'Lisää tiedosto',
  txt_progress_bar: '{{step}} / {{size}} taulukkoa',
  txt_joined: 'Yhdistetty',
  txt_joined_columns: 'Yhdistetyt sarakkeet',
  txt_maximum_selected_sheet: 'Liikaa valittuja taulukoita',
  txt_joined_columns_description:
    '{{sheet}} taulukkoa on yhdistetty seuraavien avainsarakkeiden avulla. Näiden sarakkeiden tiedot tuodaan yhteiseen sarakkeeseen.',
  txt_maximum_selected_sheet_desc:
    'Hyväksymme enintään {{size}} valittua taulukkoa.',
  txt_sheet_selection_list_title: 'Kaikki valitut',
  txt_sheet_selection_multiple_desc: 'Olet valinnut {{amount}} taulukkoa',
  txt_sheet_selection_one_desc: 'Olet valinnut {{amount}} taulukon',
  txt_join_sheets: 'Yhdistä taulukot',
  txt_title_warning_join_column: 'Avainsarakkeen valinta vaaditaan',
  txt_desc_warning_join_column:
    'Sinun on valittava jokaisen taulukon avainsarake yhdistääksesi taulukot ja jatkaaksesi tuontia.',
  txt_no_matching_entry_title: 'Ei vastaavia merkintöjä',
  txt_no_matching_entry_description_multiple:
    'Vähintään yhdessä taulukossa valitun avainsarakkeen merkinnät eivät vastaa muiden taulukoiden merkintöjä. Valitse toinen avainsarake tai lataa taulukot erikseen.',
  txt_no_matching_entry_description_single:
    'Vähintään yhdessä taulukossa valitun avainsarakkeen merkinnät eivät vastaa toisen taulukon merkintöjä. Valitse toinen avainsarake tai lataa taulukot erikseen.',
  txt_upload_exceed_max_size_error: 'Tiedosto on suurempi kuin {{sizeInMb}}MB',
  txt_title_upload_exceed_max_size_error: 'Tiedostokoon enimmäismäärä ylittyi',
  txt_manual_entry: 'Manuaalinen syöttö',
  txt_just_a_moment_please: 'Hetkinen, kiitos',
  txt_validating: 'Vahvistetaan tietoja',
  txt_file_error: 'Tuotua tiedostoa ei voitu käsitellä.',
  txt_nested_file_error:
    'Tuotua tiedostoa ei voida käsitellä. Sisäkkäiset XML- ja JSON-muodot eivät ole tuettuja.',
  txt_dropdown_options: 'Pudotusvalikon vaihtoehdot',
  txt_positive_button_close_modal: 'Mene takaisin',
  txt_negative_button_close_modal: 'Peruuta',
  txt_invalid_data_behavior_block_more_error:
    'Tietosi sisältää {{errorCount}} virhettä, jotka on korjattava',
  txt_invalid_data_behavior_block:
    'Tietosi sisältää {{errorCount}} virheen, joka on korjattava',
  txt_confirm_title_close_modal: 'Oletko varma?',
  txt_field_invalid_date:
    'Syöttö on virheellinen. Anna päivämäärä seuraavassa muodossa: {{dateFormat}}, esim. {{dateFormatExample}}',
  txt_field_invalid_date_dmy:
    'Syöttö on virheellinen. Anna päivämäärä seuraavassa muodossa: pp.kk.vvvv, esim. 14.01.2022',
  txt_field_invalid_date_mdy:
    'Syöttö on virheellinen. Anna päivämäärä seuraavassa muodossa: kk.pp.vvvv, esim. 12.31.2022',
  txt_field_invalid_date_ymd:
    'Syöttö on virheellinen. Anna päivämäärä seuraavassa muodossa: vvvv.kk.pp, esim. 2022.12.31',
  txt_invalid_format_date_iso:
    'Syöttö on virheellinen. Anna päivämäärä seuraavassa muodossa: vvvv-kk-pp, esim. 2022-01-31',
  txt_invalid_format_datetime:
    'Syöttö on virheellinen. Anna aikaleima seuraavassa muodossa: VVVV-KK-PP HH:MM:SS, esim. 2022-01-01 00:01:10',
  txt_invalid_format_time_hms:
    'Syöttö on virheellinen. Anna aika seuraavassa muodossa: HH:MM:SS (12h-muoto), esim. 00:01:10 aamulla',
  txt_invalid_format_time_hms_24:
    'Syöttö on virheellinen. Anna aika seuraavassa muodossa: HH:MM:SS (24h-muoto), esim. 23:01:10',
  txt_invalid_format_time_hm:
    'Syöttö on virheellinen. Anna aika seuraavassa muodossa: HH:MM (12h-muoto), esim. 10:01 aamulla',
  txt_invalid_format_time_hm_24:
    'Syöttö on virheellinen. Anna aika seuraavassa muodossa: HH:MM (24h-muoto), esim. 23:01',
  txt_invalid_format_email:
    'Syöttö on virheellinen. Anna kelvollinen sähköpostiosoite, esim. max@company.com',
  txt_invalid_format_url_www:
    'Syöttö on virheellinen. Anna URL seuraavassa muodossa: www.esimerkki.com',
  txt_invalid_format_url_https:
    'Syöttö on virheellinen. Anna URL seuraavassa muodossa: https://esimerkki.com',
  txt_invalid_format_url:
    'Syöttö on virheellinen. Anna URL seuraavassa muodossa: esimerkki.com',
  txt_invalid_format_phone:
    'Syöttö on virheellinen. Anna puhelinnumero, joka alkaa 0 tai +.',
  txt_invalid_format_zip_code_de:
    'Syöttö on virheellinen. Anna kelvollinen suomalainen postinumero seuraavassa muodossa: 00000',
  txt_invalid_format_percentage:
    'Syöttö on virheellinen. Anna prosenttiarvo %-merkillä tai ilman seuraavassa muodossa: 12% tai 12',
  txt_invalid_format_currency_eur:
    'Syöttö on virheellinen. Anna arvo seuraavassa muodossa: 40,12 EUR, 42,53€, 45,22 tai 4.523,23',
  txt_invalid_format_currency_usd:
    'Syöttö on virheellinen. Anna arvo seuraavassa muodossa: 40.12 USD, 42.53$, USD 35.09, $45.22 tai 4,523.23',
  txt_invalid_format_bic:
    'Syöttö on virheellinen. Anna BIC seuraavassa muodossa: XXBADEFFXXX',
  txt_invalid_format_vat_eu:
    'Syöttö on virheellinen. Anna kelvollinen eurooppalainen ALV-numero.',
  txt_invalid_format_gtin:
    'Syöttö on virheellinen. Anna kelvollinen GTIN, jossa on 8, 12, 13 tai 14 numeroa.',
  txt_invalid_format_iban:
    'Syöttö on virheellinen. Anna IBAN ilman välilyöntejä seuraavassa muodossa: DE89370400440532013000',
  txt_loading: 'Ladataan...',
  txt_create_new_option: 'Luo uusi vaihtoehto',
  txt_custom_column_description: 'Tämä sarake on sinun luomasi.',
  txt_create_new_column: 'Luo uusi sarake',
  txt_default_sheet_prefix_name: 'Taulukko',
  txt_file_format_error:
    'Tiedostomuoto on virheellinen. Lataa kelvollinen {{fileTypes}} tiedosto.',
  txt_option_custom_created_info:
    'Tämä vaihtoehto on sinun luomasi tätä tuontia varten.',
  txt_default_title_error: 'Jotakin meni pieleen',
  txt_import_error: 'Tuontivirhe',
  txt_title_error_invalid_format: 'Virheellinen formaatti',
  txt_create_custom_not_allowed:
    'Et voi luoda uutta saraketta, jos arvo sisältää vain erikoismerkkejä ja välilyöntejä.',
  txt_add_new_row: 'Lisää uusi rivi',
  txt_download_only_csv_template_desc:
    'Voit ladata olemassa olevan tiedostosi ensin painamalla "{{button_name}}". Jos kuitenkin haluat työskennellä mallipohjan kanssa, löydät CSV-latauksen yläpuolelta.',
  txt_title_info_box_automatic_mapping: 'Sarakkeiden sovitus on automatisoitu',
  txt_description_info_box_automatic_mapping:
    'Jos osa tuoduista tiedoista puuttuu tai tiedot ovat sovitettu virheellisesti, paina "Takaisin"-painiketta korjataksesi sovituksen itse.',
  txt_multiselection_allowed: 'Monivalinta sallittu',
  txt_successful_records: '{{amount}} onnistunutta merkintää',
  txt_failed_records: '{{amount}} epäonnistunutta merkintää',
  txt_import_data: 'Tuo tiedot',
  txt_edit_data_button: 'Muokkaa tietoja',
  txt_description_submit_success: 'Tietosi tuotiin onnistuneesti.',
  txt_boolean_yes: 'Kyllä',
  txt_boolean_no: 'Ei',
  txt_confirm_leave_cancel_btn: 'Ei, peruuta',
  txt_confirm_leave_confirm_btn: 'Kyllä, olen varma',
  txt_has_per_mapping_modal:
    'Jos painat "Kyllä, olen varma" -painiketta, menetät kaikkien vaiheiden koko edistymisen.',
  txt_go_back_dynamic_import_title:
    'Jos painat "Kyllä, olen varma" -painiketta, menetät kaikkien vaiheiden koko edistymisen.',
  txt_error_processing_dynamic_import_description:
    'Virhe tapahtui käsitellessäsi pyyntöäsi.',
  txt_match_column: '',
  txt_match_column_description: '',
  txt_review_entries: '',
  txt_review_entries_description: '',
  txt_retry_button: 'Yritä uudelleen',
  txt_matching_error_title: 'Jotakin meni pieleen',
  txt_matching_error_description:
    'Odottamaton virhe on tapahtunut. Yritä myöhemmin uudelleen.',
  txt_upload_chunk_error_title: 'Jotakin meni pieleen',
  txt_upload_chunk_error_description:
    'Palvelimellamme on ongelmia, voit yrittää uudelleen tai ottaa meihin yhteyttä',
  txt_invalid_options_condition:
    'Syöttö on virheellinen. Anna arvo, joka täyttää ehdot',
  txt_error_dynamic_import_not_matched_tdm:
    'Syötteen JSON avaimet eivät vastaa kohteen datamallin sarakeavaimia. Muokkaa joko JSON-avaimet tai datamallin sarakeavaimet varmistaaksesi, että ne vastaavat.',
  txt_error_dynamic_import_no_support:
    'Dynaaminen tuontitoiminto ei ole sisällytetty tilausohjelmaasi ja on tällä hetkellä epäaktiivinen. Jos sinulla on kysymyksiä, ota meihin yhteyttä saadaksesi apua.',
  txt_error_dynamic_import_unknown:
    'Tapahtui määrittelemätön virhe. Viittaa asiakirjaan ja ota yhteyttä tukitiimiin, jos tätä ongelmaa ei voida ratkaista.',
  txt_error_dynamic_import_invalid_data_format:
    'Syöttötietojen muoto ei vastaa odotettua rakennetta määritellylle vaiheelle. Harkitse joko syöttötietojen rakenteen muuttamista tai aloittamista alusta. Lisätietoja varten katso asiakirjaamme.',
  txt_invalid_license_key_description:
    "Lisenssiavain on virheellinen tai on vanhentunut. Tarkista lisenssiavain, selaimesi 'white list' ja <i>developerMode</i> -ominaisuus.",
  txt_invalid_license_key: 'Virheellinen lisenssiavain',
  txt_preview: 'Esikatselu',
  'txt_preview-sheet': 'Esikatselutaulukko',
  txt_expand_view: 'Laajenna näkymä',
  txt_collapse_view: 'Yhdistä näkymä',
  txt_select_or_add: 'Valitse tai lisää sarake',
  txt_create_new_option_description:
    'Lisää uusi vaihtoehto, joka antaa tarkemman esityksen tiedoistasi. Määritä vaihtoehto antamalla sille nimi ja valitsemalla tyyppi.',
  txt_create_new_column_description:
    'Laajenna kohdedatamallia lisäämällä uusi sarake. Määritä sarakkeen nimi ja valitse sen sisältämä datatyyppi.',
  txt_create_new_column_column_name_field_description:
    'Anna kuvaava nimi uudelle sarakkeellesi.',
  txt_create_new_column_column_type_field_description:
    'Valitse sarakkeen sisältämä datatyyppi (esim. Teksti, Numero, Päivämäärä jne.).',
  txt_create_new_column_column_name_field: 'Sarakkeen nimi',
  txt_create_new_column_column_type_field: 'Sarakkeen tyyppi',
  txt_create_new_column_column_name_field_placeholder: 'Anna sarakkeen nimi',
  txt_create: 'Luo',
  txt_require_field: 'Pakollinen kenttä',
  txt_select_column_type: 'Valitse sarakkeen tyyppi',
  txt_date_format: 'Päivämäärämuoto',
  txt_select_date_format: 'Valitse päivämäärämuoto',
  txt_option_name: 'Vaihtoehdon nimi',
  txt_option_type: 'Vaihtoehdon tyyppi',
  txt_create_new_option_option_name_field_placeholder: 'Anna vaihtoehdon nimi',
  txt_select_option_type: 'Valitse vaihtoehdon tyyppi',
  txt_create_new_option_option_name_field_description:
    'Anna kuvaava nimi uudelle vaihtoehdollesi.',
  txt_create_new_option_option_type_field_description:
    'Valitse vaihtoehdon tietotyyppi (esim. Teksti, Kokonaisluku, desimaaliluku).',
  txt_data_type_string: 'Teksti (String)',
  txt_data_type_int: 'Kokonaisluku (Int)',
  txt_data_type_float: 'Desimaaliluku (Float)',
  txt_data_type_boolean: 'Kyllä/Ei pudotusvalikko (Boolean)',
  txt_data_type_bic: 'Pankkitunnus (BIC)',
  txt_data_type_currency_eur: 'Valuutta EUR (12,34€)',
  txt_data_type_currency_usd: 'Valuutta USD ($12.34)',
  txt_data_type_date: 'Päivämäärä/Aikaleima',
  txt_data_type_email: 'Sähköpostiosoite',
  txt_data_type_vat_eu: 'Eurooppalainen ALV-numero',
  txt_data_type_gtin: 'GTIN/EAN',
  txt_data_type_iban: 'IBAN',
  txt_data_type_percentage: 'Prosentti',
  txt_data_type_phone: 'Puhelinnumero, joka alkaa 0 tai +',
  txt_data_type_url: 'URL',
  txt_data_type_url_https: 'URL, jossa on https',
  txt_data_type_url_www: 'URL, jossa on www',
  txt_data_type_url_zip_code: 'POSTINUMERO FI',
  txt_date_format_dd_mm_yyyy: 'Päivämäärä DMY (PP.KK.VVVV)',
  txt_date_format_mm_dd_yyyy: 'Päivämäärä MDY (KK.PP.VVVV)',
  txt_date_format_mm_dd_yyyy_slash: 'Päivämäärä MDY (KK/PP/VVVV)',
  txt_date_format_iso: 'Päivämäärä ISO (VVVV-KK-PP)',
  txt_date_format_sql: 'Päivämäärä SQL (VVVV-KK-PP HH:mm:ss)',
  txt_date_format_iso_8061_timestamp:
    'ISO 8601 aikaleima (VVVV-KK-PPTHH:mm:ssZ)',
  txt_date_format_unix_timestamp: 'Unix aikaleima (X)',
  txt_date_format_time_12hr: 'Aika 12h (hh:mm)',
  txt_date_format_time_24hr: 'Aika 24h (HH:mm)',
  txt_date_format_time_12hr_ss: 'Aika 12h (hh:mm:ss)',
  txt_date_format_time_24hr_ss: 'Aika 24h (HH:mm:ss)',
  txt_select_or_add_dropdown_option: 'Valitse tai lisää vaihtoehto',
  txt_options: 'Vaihtoehdot',
  txt_date_format_field_description:
    'Valitse haluamasi aikaleimaformaatti annetuista vaihtoehdoista.',
  txt_field_invalid_dup_column_label: 'Sarake on jo olemassa',
  txt_field_invalid_dup_option_label: 'Vaihtoehto on jo olemassa',
  txt_message_int_only_numbers: 'Vain numerot sallittu',
  txt_message_float_only_numbers: 'Vain numerot sallittu (esim. 12.34)',
  txt_confirm_delete_rows:
    'Jos painat "Poista kaikki" -painiketta, {{selectedRow}} valittua riviä poistetaan.',
  txt_delete_all: 'Poista kaikki',
  txt_all_rows: 'Kaikki rivit',
  txt_count_selected: '{{count}} valittua',
  txt_sort_asc: 'Lajittele nousevasti',
  txt_sort_desc: 'Lajittele laskevasti',
  txt_remove_sort: 'Poista lajittelu',
  txt_freeze_column: 'Jäädytä sarake',
  txt_unfreeze_column: 'Vapauta sarake',
  txt_hide_column: 'Piilota sarake',
  txt_filter: 'Suodata',
  txt_filter_by_condition: 'Suodata ehdon mukaan',
  txt_filter_condition_none: 'Ei mitään',
  txt_filter_condition_is_empty: 'On tyhjä',
  txt_filter_condition_is_not_empty: 'Ei ole tyhjä',
  txt_filter_condition_is_equal_to: 'On yhtä suuri kuin',
  txt_filter_condition_is_not_equal_to: 'Ei ole yhtä suuri kuin',
  txt_filter_condition_begins_with: 'Alkaa',
  txt_filter_condition_ends_with: 'Päättyy',
  txt_filter_condition_contains: 'Sisältää',
  txt_filter_condition_does_not_contain: 'Eivät sisällä',
  txt_filter_condition_is_error: 'On virhe',
  txt_filter_condition_is_warning: 'On varoitus',
  txt_filter_condition_is_info: 'On info',
  txt_filter_condition_greater_than: 'Suurempi kuin',
  txt_filter_condition_greater_than_or_equal: 'Suurempi tai yhtä suuri kuin',
  txt_filter_condition_less_than: 'Pienempi kuin',
  txt_filter_condition_less_than_or_equal: 'Pienempi tai yhtä suuri kuin',
  txt_filter_condition_is_between: 'On välillä',
  txt_filter_condition_is_not_between: 'Ei ole välillä',
  txt_filter_condition_date_before: 'Ennen',
  txt_filter_condition_date_after: 'Jälkeen',
  txt_filter_condition_date_tomorrow: 'Huomenna',
  txt_filter_condition_date_today: 'Tänään',
  txt_filter_condition_date_yesterday: 'Eilen',
  txt_filter_add_value_placeholder: 'Lisää arvo',
  txt_filter_item_selected: '{{count}} valittua',
  txt_filter_by_value: 'Suodata arvon mukaan',
  txt_filter_apply: 'Käytä',
  txt_filter_clear_one: 'Tyhjennä suodatin',
  txt_filter_clear_other: 'Tyhjennä kaikki suodattimet',
  txt_clear: 'Tyhjennä',
  txt_logic_and: 'Ja',
  txt_logic_or: 'Tai',
  txt_no_results_found: 'Tuloksia ei löytynyt',
  txt_hide_column_maximum_info:
    'Olet saavuttanut maksimin: Et voi piilottaa kaikkia sarakkeita. Poista ainakin yksi sarake näkyvistä jatkaaksesi.',
  txt_freeze_column_maximum_info:
    'Olet saavuttanut maksimin: Voit jäädyttää vain kaksi saraketta kerrallaan. Poista ainakin yksi sarake näkyvistä jatkaaksesi.',
  txt_select_all: 'Valitse kaikki',
  txt_find_and_replace: 'Etsi & korvaa',
  txt_find: 'Etsi',
  txt_find_by_column: 'Etsi sarakkeittain',
  txt_exact_match: 'Tarkka osuvuus',
  txt_replace_with: 'Korvaa',
  txt_replace: 'Korvaa',
  txt_replace_all: 'Korvaa kaikki',
  txt_matches_found_one: '{{count}} osuvuus löytyi',
  txt_matches_found_other: '{{count}} osuvuuksia löytyi',
  txt_select_column_placeholder: 'Valitse vähintään 1 sarake',
  txt_matches_hidden: '{{count}} piilotettu',
  txt_confirm_replace_all_one:
    'Jos painat "Korvaa kaikki" -painiketta, <b>{{count}} arvo</b> korvataan.',
  txt_confirm_replace_all_other:
    'Jos painat "Korvaa kaikki" -painiketta, <b>{{count}} arvoa</b> korvataan.',
  txt_unable_replace_value:
    'Et voi korvata kategoriasolun arvoa toisella arvolla.',
  txt_confirm_delete_custom_column:
    'Jos painat "Poista" -painiketta, tämä muokattu sarake poistetaan.',
  txt_edit: 'Muokkaa',
  txt_change_custom_column: 'Muuta sarake',
  txt_change_custom_column_description:
    'Säädä sarakkeen nimeä, jotta se sopii paremmin sen sisältämään tietoon.',
  txt_save: 'Tallenna',
  txt_change_custom_column_type_description:
    'Jos haluat vaihtaa sarakkeen tyyppiä, poista tämä sarake ja luo uusi.',
  txt_change_custom_column_date_format_description:
    'Jos haluat vaihtaa päivämäärämuotoa, poista tämä sarake ja luo uusi.',
  txt_cleaning_assistant: 'Siivoa tiedot',
  txt_cleanings: '{{count}} puhdistusta',
  txt_empty_get_cleanings_title: 'Ei siivouksia',
  txt_empty_get_cleanings_message: 'Ei siivoussuosituksia.',
  txt_dismiss: 'Hylkää',
  txt_apply: 'Käytä',
  txt_get_cleanings_fail_title: 'Jotakin meni pieleen',
  txt_get_cleanings_fail_message: 'Siivoussuositusten hakeminen epäonnistui',
  txt_cleanings_row_limit:
    'Olemme luoneet siivouksia vain ensimmäisille {{n}} virheellisille riveille',
  txt_cleanings_available_in: 'Seuraavat siivoukset saatavilla',
  txt_join_sheets_percent_unique_match:
    '{{percent}}% riveistä voidaan yksilöidä ainutlaatuisesti',
  txt_join_sheet_desc:
    'Valitse taulukot, jotka haluat liittää tai yhdistää yhteisten sarakkeiden avulla luodaksesi yksittäinen tietojoukko ja jatka.',
  txt_joined_sheets: 'Yhdistetyt taulukot',
  txt_no_sheet_joined: 'Ei yhdistettyä taulukkoa',
  txt_unselected_sheets: 'Valitsemattomat taulukot',
  txt_no_sheet_select: 'Ei valittavaa taulukkoa',
  txt_join_on_columns: 'Yhdistä tiedot',
  txt_append_to_columns: 'Liitä tiedot',
  txt_no_joined_dataset: 'Ei yhdistettyä tietojoukkoa',
  txt_no_joined_dataset_desc: 'Et ole vielä valinnut mitään taulukkoja.',
  txt_join_sheet_modal_desc:
    'Valitse sarakkeet, jotka ovat molemmissa taulukoissa ja yksilöivät jokaisen rivin tarkasti yhdistääksesi tiedot.',
  txt_joined_dataset: 'Yhdistetty tietojoukko',
  txt_select_column: 'Valitse sarake',
  txt_select_output_col: 'Valitse tulossarake',
  txt_join: 'Yhdistä',
  txt_add_col: 'Lisää sarake',
  txt_join_sheets_percent_unique_match_desc:
    'Lisää sarakkeita yksilöidäksesi lisää',
  txt_no_column_select: 'Ei valittua saraketta',
  txt_no_column_select_join_desc:
    'Et ole valinnut mitään sarakkeita yhdistettäväksi. Tämä lisää <b>{{sheetName}}</b> tiedot yhdistetyn tietojoukon loppuun. Oletko varma, että haluat jatkaa?',
  txt_append_column: 'Liitä sarakkeet',
  txt_append_column_modal_desc:
    'Valitse sarakkeet, joiden arvot haluat lisätä vastaaviin sarakkeisiin yhdistetyssä tietojoukossa.',
  txt_append_to_join_dataset: 'Liitä yhdistettyyn tietojoukkoon',
  txt_append: 'Liitä',
  txt_no_column_select_append_desc:
    'Valitse vähintään yksi sarake lisätäksesi tietoja.',
  txt_unjoined_sheets: 'Yhdistämättömät taulukot',
  txt_unjoined_sheets_desc:
    'Et ole yhdistänyt kaikkia taulukoita. Et voi käyttää mitään tietoja niistä. Oletko varma, että haluat jatkaa?',
  txt_remove_join_sheet:
    'Oletko varma, että haluat poistaa <i>{{sheetName}}</i>?',
  txt_remove_join_sheet_desc:
    'Olet käyttänyt sarakkeita <b>{{sheetName}}</b> yhdistääksesi muita taulukkoja. Seuraavat taulukot poistetaan myös:',
  txt_sheets: 'Taulukot',
  txt_join_sheets_percent_matched:
    '{{percent}}% riveistä voidaan yhdistää ainutlaatuisesti',
  txt_joined_data_from: 'Yhdistetyt tiedot lähteestä:',
  txt_data_from: 'Tiedot lähteestä:',
  txt_entry_not_editable: 'Tätä merkintää ei voi muokata',
  txt_unable_replace_disabled_cell_value:
    'Et voi korvata käyttämättömän solun arvoa eri arvolla.',
  txt_unable_to_replace_category_disabled_cell:
    'Huomaa, että kategoriasarakoiden ja käyttämättömien solujen arvoja ei voida korvata.',
  txt_unable_to_replace_disabled_cell:
    'Huomaa, että käyttämättömien solujen arvoja ei voida korvata.',
  txt_unable_to_replace_category_cell:
    'Huomaa, että kategoriasarakkeiden arvoja ei voida korvata.',
  txt_use_contextual_engine: 'Käytä kontekstuaalista konetta',
  txt_use_contextual_engine_desc:
    'Anna kontekstuaalisen koneen hoitaa kaikki, kartoituksesta tiedon muuntamiseen ja siivoamiseen, kaikki yhdessä. Tarpeen mukaan voit tarkistaa tiedot ja tehdä lopulliset säädöt viimeisessä vaiheessa.',
  txt_skip_for_now: 'Ohita nyt',
  txt_processing_data: 'Käsitellään tietoja',
  txt_process_contextual_failed_title:
    'Kontekstuaalisen koneen suorittaminen epäonnistui',
  txt_process_contextual_failed_desc:
    'Kontekstuaalinen kone ei pystynyt muuttamaan tietoja tarpeen mukaan. Jatka manuaalista tuontia. Manuaalisessa tuontivaiheessa yleistietosarake havaitaan automaattisesti, ja tiedot kartoituvat. Sinun on kuitenkin tarkasteltava, siivottava ja viimeisteltävä tiedot ennen lähettämistä.',
  txt_continue_with_manual_input: 'Jatka manuaalisella tuonnilla',
  txt_switch_manual_import_title: 'Vaihtoehto manuaaliseen tuontiin',
  txt_switch_manual_import_desc:
    'Manuaaliseen tuontivaihtoehtoon vaihtaminen tunnistaa automaattisesti päälöydetyn sarakkeen ja kartoi tiedot. Sinun on kuitenkin tarkasteltava, siivottava ja viimeisteltävä tiedot ennen lähettämistä.',
  txt_did_you_expect_different_result: 'Odotitko erilaista tulosta?',
  txt_thinking: 'Ajattelen',
  txt_default_alert_title: 'Oletko varma, että haluat jatkaa?',
  txt_default_alert_description:
    'Joihinkin vaadittuihin vaiheisiin ei ehkä ole vielä vastattu.',
  txt_default_alert_cancel_btn: 'Peruuta',
  txt_default_alert_continue_btn: 'Jatka',
  txt_default_block_title: 'Ei voida jatkaa',
  txt_default_block_description: 'Jotakin meni pieleen. Yritä uudelleen.',
  txt_default_block_close_btn: 'Sulje',
  txt_step_handler_invalid_data:
    'Syöttötietojen muoto ei vastaa odotettua rakennetta seuraavalle vaiheelle. Muokkaa tietorakennetta vastaavasti. Lisätietoja varten katso asiakirjaamme.',
  txt_fix_errors: 'Korjaa virheet',
  txt_clean_rows: 'Puhdista rivit',
  txt_error_rows: 'Virheelliset rivit',
  txt_confirm_submit_data_with_error_discard:
    'Oletko varma, että haluat lähettää tietosi?<br/>Rivejä, jotka sisältävät vähintään yhden virheen, ei ladata.',
  txt_confirm_submit_data_with_error_submit:
    'Oletko varma, että haluat lähettää tietosi?<br/>Puhtaat ja virheelliset rivit tuodaan.',
  txt_export_error_rows: 'Vie virheelliset rivit',
  txt_import_rows: 'Tuo rivit',
  txt_ready_to_submit_title: 'Valmis lähettämään?',
  txt_contains_error_row_one:
    'Tietosi sisältävät {{errorCount}} virheellisen rivin, joka on korjattava',
  txt_contains_error_row_other:
    'Tietosi sisältävät {{errorCount}} virheellistä riviä, jotka on korjattava',
  txt_apply_to_column: 'Aseta sarakkeeseen',
  txt_add_cleaning: 'Lisää puhdistus',
  txt_update_cleaning: 'Päivitä siivous',
  txt_test_prompt: 'Testaa kehotetta',
  txt_show_examples: 'Näytä esimerkkejä',
  txt_hide_examples: 'Piilota esimerkit',
  txt_examples: 'Esimerkit',
  txt_to_insert_column: 'lisätäksesi sarakkeen',
  txt_error_message_formula: 'virheMessageKaava',
  txt_enter_formula: 'Anna kaava',
  txt_add_your_function_here: 'Lisää funktiosi tänne',
  txt_test_function: 'Testaa funktiota',
  txt_type: 'Tyyppi',
  txt_discard: 'Hylkää',
  txt_discard_changes: 'Hylkää muutokset',
  txt_discard_changes_desc:
    'Kaikki muutokset hylätään, jos poistut tästä vaiheesta. Oletko varma, että haluat poistua ilman tallennusta?',
  txt_apply_only_to_entries_with_errors:
    'Käytä vain virheellisiin merkintöihin',
  txt_function: 'Funktio',
  txt_prompt: 'Kehote',
  txt_remove: 'Poista',
  txt_prompt_down_error_message:
    'Kehotteen lähettäminen epäonnistui, yritä uudelleen.',
  txt_prompt_failed_error_message: 'Yritä uudelleen erilaisella kehoteella.',
  txt_invalid_syntax: 'Virheellinen syntaksi.',
  txt_successful: 'Onnistuu',
  txt_prompt_reached_max_length: 'Merkkiraja saavutettu.',
  txt_prompts_prompt_example_1:
    'Korvaa tyhjät solut <a>@Status</a> arvolla "Tuntematon"',
  txt_prompts_prompt_example_2: 'Hae vuosi <a>@Ostopäivämäärä</a>',
  txt_prompts_prompt_example_3:
    'Yhdistä <a>@Etunimi</a> ja <a>@Sukunimi</a> välissä oleva välilyönti',
  txt_prompts_prompt_example_4: '',
  txt_prompts_prompt_example_5: '',
  txt_prompts_function_example_1:
    '<a>@Tilauksen tila</a>.replace("pending", "Käsittelyssä")',
  txt_prompts_function_example_2:
    '<a>@Varasto</a> === 0 ? "Loppuunmyyty" : <a>@Tila</a>',
  txt_prompts_function_example_3: '<a>@Hinta per Yksikkö</a> * <a>@määrä</a>',
  txt_prompts_function_example_4: '',
  txt_prompts_function_example_5: '',
  txt_done: 'Valmis',
  txt_imported_rows: 'Tuodut rivit',
  txt_failed_rows: 'Epäonnistuneet rivit',
  txt_submitting_data: 'Lähetetään tietoja',
  txt_confirm_submit_data_with_error_block:
    'Oletko varma, että haluat lähettää tietosi?',
  txt_add_your_prompt_here: 'Lisää kehote tähän',
  txt_no_results: 'Ei tuloksia',
  txt_no_results_desc: 'Emme löydä mitään virheellisiä merkintöjä.',
  txt_export_all_rows: 'Vie kaikki rivit',
  txt_unable_to_export:
    'Ei voida viedä Excel-tiedostoa, jossa on yli 100.000 riviä',
  txt_create_custom_column: 'Luo mukautettu sarake',
  txt_match_auto_by_sheet_column: 'Automaattisesti vastattu',
  txt_mapping_required: 'Kartoitus vaaditaan',
  txt_match_manual_by_sheet_column: 'Vastattu',
  txt_page_info: 'Info',
  txt_transpose: 'Käännä',
  txt_transpose_row_limit_message:
    'Voit kääntää tietosi vain, jos tietojoukko sisältää vähemmän kuin 10.000 riviä.'
};
